import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';

// Toast
import { toast } from 'react-toastify';

// Auth
import { AuthContext } from '../../../utilities/auth-context';

// Components
import ConfirmModal from '../confirm-modal';
import UserModal from './user-modal';

// MUI Components
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const emptyUser = {
    id: null,
    name: '',
    email: '',
    password: '',
};

const Users = () => {

    const { state } = useContext(AuthContext);

    const [ users, setUsers ]                                       = useState([]);
    const [ confirmDeleteUserOpen, setConfirmDeleteUserOpen ]       = useState(false);
    const [ confirmDeleteUserId, setConfirmDeleteUserId ]           = useState(null);
    const [ editUser, setEditUser ]                                 = useState(emptyUser);

    const getUsers = () => {
        axios.get('/users-for-editing').then(response => {
            setUsers(response.data.users);
        });
    }

    const openUser = (user) => {
        setEditUser({
            id: user.id,
            name: user.name,
            email: user.email,
            password: '',
        });
    }

    const clearUser = () => {
        setEditUser(emptyUser);
        getUsers();
    }

    const requestDeleteUser = () => {
        setConfirmDeleteUserId(editUser.id);
        setConfirmDeleteUserOpen(true);
    }

    const confirmDeleteUser = () => {
        setConfirmDeleteUserOpen(false);
        axios.post(`/user/${confirmDeleteUserId}/delete`).then(response => {
            if( response.data.success ){
                toast.success('User deleted successfully');
                clearUser();
            }
            else{
                toast.error(response.data.message);
            }
        });
    }

    const formatDate = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleDateString();
    }

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <Box className='users-container'>
            <ConfirmModal
                open={confirmDeleteUserOpen}
                setOpen={setConfirmDeleteUserOpen}
                title='Delete User'
                message='Are you sure you want to delete this user?'
                onConfirm={confirmDeleteUser}
                onCancel={() => setConfirmDeleteUserOpen(false)}
            />
            <UserModal
                user={editUser}
                setUser={setEditUser}
                clearUser={clearUser}
                onDelete={requestDeleteUser}
            />
            <Box className='table-actions-bar'>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={() => setEditUser({
                        id: 'new',
                        name: '',
                        email: '',
                        password: '',
                    })}
                >
                    Add User
                </Button>
            </Box>
            {users.length > 0 ? (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Created</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((user) => (
                            <TableRow
                                key={user.id}
                                hover
                                onClick={() => openUser(user)}
                                sx={{ cursor: 'pointer' }}
                            >
                                <TableCell>
                                    {user.name}
                                    {state.user === user.id ? ' (you)' : ''}
                                </TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{formatDate(user.created_at)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            ) : (
                <Typography variant='body1'>No users found.</Typography>
            )}
        </Box>
    );

}

export default Users;
